import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { getReadChapters } from "../lib/storage";
import { getBooks } from "../api";
import { BookOpen, History } from "lucide-react";

export default function ReadingHistory({ open, onOpenChange }) {
  const navigate = useNavigate();
  const [names, setNames] = useState({});

  useEffect(() => {
    if (open && Object.keys(names).length === 0) {
      getBooks().then((bs) => setNames(Object.fromEntries(bs.map((b) => [b.id, b.name]))));
    }
  }, [open]); // eslint-disable-line

  const entries = Object.entries(getReadChapters())
    .map(([k, ts]) => {
      const [b, c] = k.split("_");
      return { b, c: parseInt(c, 10), ts };
    })
    .sort((a, b) => b.ts - a.ts);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="font-ui max-h-[80vh] overflow-y-auto" data-testid="reading-history">
        <DialogHeader>
          <DialogTitle className="font-serif-display flex items-center gap-2 text-2xl">
            <History className="h-5 w-5 text-primary" /> Reading History
          </DialogTitle>
          <DialogDescription className="sr-only">Chapters you have read, most recent first</DialogDescription>
        </DialogHeader>
        {entries.length === 0 ? (
          <p className="py-6 text-center text-sm text-muted-foreground">
            No chapters read yet — your finished chapters will appear here.
          </p>
        ) : (
          <div className="space-y-2">
            {entries.map((e, i) => (
              <button
                key={i}
                data-testid={`history-${e.b}-${e.c}`}
                onClick={() => { onOpenChange(false); navigate(`/read/${e.b}/${e.c}`); }}
                className="flex w-full items-center justify-between rounded-xl border border-border p-3 text-left transition-colors hover:border-primary hover:bg-muted"
              >
                <span className="flex items-center gap-2 text-sm font-medium">
                  <BookOpen className="h-4 w-4 text-primary" /> {names[e.b] || e.b} {e.c}
                </span>
                <span className="text-xs text-muted-foreground">
                  {new Date(e.ts).toLocaleDateString(undefined, { month: "short", day: "numeric" })}
                </span>
              </button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
